import PropTypes from 'prop-types'
import React, { useEffect } from "react"

import { Switch, BrowserRouter as Router } from "react-router-dom"
import { connect } from "react-redux"

// Import Routes all
import { userRoutes, authRoutes } from "./routes/allRoutes"

// Import all middleware
import Authmiddleware from "./routes/middleware/Authmiddleware"

// layouts Format
import VerticalLayout from "./components/VerticalLayout/"
import HorizontalLayout from "./components/HorizontalLayout/"
import NonAuthLayout from "./components/NonAuthLayout"

import Config, { ActiveClient } from "./config";
const theme = (!ActiveClient) ? "dark" : Config[ActiveClient].theme;
//console.log(theme);

//import "./assets/scss/theme.scss";
(theme == 'dark') ? import('./assets/scss/theme-dark.scss') : import('./assets/scss/theme.scss')

// Import Firebase Configuration file
// import { initFirebaseBackend } from "./helpers/firebase_helper"

import fakeBackend from "./helpers/AuthType/fakeBackend"
import { isExpired } from "react-jwt"
// Activating fake backend
// fakeBackend()


// init firebase backend
// initFirebaseBackend(firebaseConfig)

import { useHistory } from "react-router-dom";

const App = (props) => {

  const history = useHistory(); // Create a history object
  useEffect(() => {
    // Check the token's expiration status every minute
    const checkTokenExpiration = setInterval(() => {
      const token = localStorage.getItem("authToken");
      if (token && isExpired(token)) {
        // Token has expired; log the user out

        clearInterval(checkTokenExpiration); // Stop checking after logging out

        // Display an alert message
        window.alert("Your session has expired. Please log in again.");

        // Redirect to the login page
        window.location.href = "/login";
        localStorage.removeItem("authToken")

      }
    }, 60000); // Check every minute (adjust as needed)

    return () => {
      clearInterval(checkTokenExpiration); // Clean up the timer when the component unmounts
    };
  }, [history]);

  const isMyTokenExpired = isExpired(localStorage.getItem("authToken") || "null")

  function getLayout() {
    let layoutCls = VerticalLayout
    switch (props.layout.layoutType) {
      case "horizontal":
        layoutCls = HorizontalLayout
        break
      default:
        layoutCls = VerticalLayout
        break
    }
    return layoutCls
  }

  const Layout = getLayout()
  return (
    <React.Fragment>
      <Router>
        <Switch>
          {authRoutes.map((route, idx) => (
            <Authmiddleware
              path={route.path}
              layout={NonAuthLayout}
              component={route.component}
              key={idx}
              isAuthProtected={false}
              exact
            />
          ))}

          {userRoutes.map((route, idx) => (
            <Authmiddleware
              path={route.path}
              layout={Layout}
              component={route.component}
              key={idx}
              isAuthProtected={true}
              isExpired={false}
              exact
            />
          ))}
        </Switch>
      </Router>
    </React.Fragment>
  )
}

App.propTypes = {
  layout: PropTypes.any
}

const mapStateToProps = state => {
  return {
    layout: state.Layout,
  }
}

export default connect(mapStateToProps, null)(App)
